import { generateId } from '@/lib/utils'

const searchDataRaw = [
  {
    label: 'results.aboutUs',
    href: '/about'
  },
  {
    label: 'results.services',
    href: '/services'
  },
  {
    label: 'results.digitalWallet',
    href: '/digital-wallet'
  },
  {
    label: 'results.digitalCard',
    href: '/digital-card'
  },
  {
    label: 'results.branches',
    href: '/branches'
  },
  {
    label: 'results.benefits',
    href: '/benefits'
  },
  {
    label: 'results.contactUs',
    href: '/contact-us'
  },
  {
    label: 'results.faq',
    href: '/faq'
  },
  {
    label: 'results.legalActs',
    href: '/general#legalActs'
  },
  { href: '/general#shareholders', label: 'results.shareholders' },
  { href: '/general#reports', label: 'results.reports' },
  { href: '/general#documents', label: 'results.documents' },
  { href: '/general#complaints', label: 'results.complaints' },
  {
    href: '/useful-information#financialMediator',
    label: 'results.financialMediator'
  },
  {
    href: '/useful-information#announcements',
    label: 'results.announcements'
  },
  {
    href: '/useful-information#links',
    label: 'results.usefulLinks'
  }
]

export const SEARCH_DATA = searchDataRaw.map((item) => ({
  ...item,
  id: generateId(item.href, item.label)
}))
